export enum ExportationType {
  UNIFIED_EXPORT_PUMP_STATUS = "UNIFIED",
  GROUPED_EXPORT_PUMP_STATUS = "GROUPED"
}
